import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandGoogle(props: IconProps) {
  return (
    <BaseIcon size={40} {...props}>
      <path
        d="M21 12.514c0-.632-.05-1.268-.158-1.89H12.18v3.581h4.96a4.308 4.308 0 0 1-1.836 2.826v2.324h2.959C20.002 17.735 21 15.343 21 12.514Z"
        fill="#4285F4"
      />
      <path
        d="M12.181 21.6c2.477 0 4.565-.824 6.087-2.245l-2.96-2.324c-.823.568-1.885.889-3.124.889-2.395 0-4.426-1.637-5.155-3.838H3.976v2.396c1.558 3.14 4.733 5.122 8.205 5.122Z"
        fill="#34A853"
      />
      <path
        d="M7.025 14.082a5.638 5.638 0 0 1 0-3.56V8.125h-3.05a9.415 9.415 0 0 0 0 8.352l3.05-2.396Z"
        fill="#FBBC04"
      />
      <path
        d="M12.181 6.68a4.955 4.955 0 0 1 3.522 1.395l2.622-2.656A8.764 8.764 0 0 0 12.181 3C8.709 3 5.534 4.982 3.976 8.126l3.05 2.395c.725-2.204 2.76-3.84 5.155-3.84Z"
        fill="#EA4335"
      />
    </BaseIcon>
  );
}
